<template>
    <tbody>
        <tr :key=mapping.Id v-for="(mapping, index) in group.mappings">
            <td v-if="group.kind === 'jira' && index === 0" :rowspan="groupLength" class="tfs4jira-mapping-row-left">
                <span> {{mapping.JiraField.Value}} </span>
                <span v-if="mapping.JiraField.HasInfo" v-tooltip="{html: mapping.jiraInfoTooltip}">
                    <div :class="mapping.JiraField.Info.Type"></div>
                    <div :id="mapping.jiraInfoTooltip" v-html="mapping.JiraField.Info.Message">
                    </div>
                </span>
            </td>
            <td v-show="group.kind !== 'jira'" class="tfs4jira-mapping-row-left">
                <span> {{mapping.JiraField.Value}} </span>
                <span v-if="mapping.JiraField.HasInfo" v-tooltip="{html: mapping.jiraInfoTooltip}">
                    <div :class="mapping.JiraField.Info.Type"></div>
                    <div :id="mapping.jiraInfoTooltip" v-html="mapping.JiraField.Info.Message">
                    </div>
                </span>
                <div v-if="mapping.isLastInTfsGroup && selectedJiraField">
                    <span class="field-inline-link-button"  @click="addJiraFieldToGroup(selectedJiraField, mapping)"> + add selected field
                    </span>
                </div>
            </td>
            <td class="tfs4jira-mapping-row-direction">
                <div v-if="mapping.Default || group.kind === 'none'" :class="'tfs4jira-mapping-row-direction' + mapping.Direction"></div>
                <div v-else>
                     <div v-show="group.kind === 'jira' && mapping.Direction != '-tfs-to-jira'" :class="'tfs4jira-mapping-row-direction-jira-to-tfs'"></div>
                     <div v-show="group.kind === 'tfs' && mapping.Direction != '-jira-to-tfs'" :class="'tfs4jira-mapping-row-direction-tfs-to-jira'"></div>
                </div>
            </td>
            <td v-if="group.kind === 'tfs' && index === 0" :rowspan="groupLength"  class="tfs4jira-mapping-row-right">
                <span> {{mapping.TfsField.Value}} </span>
                <span v-if="mapping.TfsField.HasInfo" v-tooltip="{html: mapping.tfsInfoTooltip}">
                    <div class="info"></div>
                    <div :id="mapping.tfsInfoTooltip" v-html="mapping.TfsField.Info.Message">
                    </div>
                </span>
            </td>
            <td v-show="group.kind !== 'tfs'" class="tfs4jira-mapping-row-right">
                <span> {{mapping.TfsField.Value}} </span>
                <span v-if="mapping.TfsField.HasInfo" v-tooltip="{html: mapping.tfsInfoTooltip}">
                    <div class="info"></div>
                    <div :id="mapping.tfsInfoTooltip" v-html="mapping.TfsField.Info.Message">
                    </div>
                </span>
                <div v-if="mapping.isLastInJiraGroup && selectedTfsField">
                    <span class="field-inline-link-button" @click="addTfsFieldToGroup(selectedTfsField, mapping)"> + add selected field
                    </span>
                </div>
            </td>
            <td class="mapping-set-primary">
                <span class="fields-mapping-group-settings">
                    <div class="fields-mapping-default" v-if="mapping.Default && groupLength > 1">
                        Primary
                    </div>
                    <div v-else v-show="!selectedJiraField && !selectedTfsField">
                        <a class="fields-mapping-set-default" v-if="group.mappings.length > 1" @click="setAsDefault(mapping)"> Set as primary</a>
                    </div>
                </span>
            </td>
            <td class="mapping-row-settings">
                <div class="mapping-value-settings">
                    <button @click="removeMappingFromGroup(mapping, group)" class="tfs4jira-mapping-row-operation tfs4jira-mapping-remove tfs4jira-rounded-button" title="Remove">
                        <img :src="imagePath +'delete-icon.svg'">
                    </button>
                    <button v-if="mapping.NeedsAttention" @click="editValues(mapping)" class="tfs4jira-mapping-row-operation tfs4jira-mapping-edit tfs4jira-rounded-button mapping-needs-attention" v-tooltip="{html: mapping.Id}" :disabled="mapping.Immutable">
                        <img :src="imagePath + 'field-values-icon-active.svg'">
                        <div :id="mapping.Id">
                            <span v-if="mapping.MappingMode === 3">No users are currently mapped - define them using this button
                                <span v-if="!isWizardView"> or enter Users Mapping</span>
                            </span>
                            <span v-else>No values are currently mapped - define them using this button</span>
                        </div>
                    </button>
                    <button v-else @click="editValues(mapping)" class="tfs4jira-mapping-row-operation tfs4jira-mapping-edit tfs4jira-rounded-button" title="Edit"  :disabled="mapping.Immutable">
                        <img :src="imagePath + 'field-values-icon.svg'">
                    </button>
                </div>
            </td>
        </tr>
    </tbody>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';
    import { NAMESPACE as FIELDS_MAPPING_NAMESPACE } from '../store/modules/fieldsMapping.js';
    import { NAMESPACE as APP_NAMESPACE } from './../store/modules/app.js';
    import Vue from 'vue';
    import Tooltip from "vue-directive-tooltip";
    import './../assets/css/tooltip.css';
    Vue.use(Tooltip);

    export default {
        props: ['groupLength', 'group', 'guid', 'isWizardView'],
        computed: mapGetters({
                selectedJiraField: FIELDS_MAPPING_NAMESPACE.getters.SELECTED_JIRA_FIELD,
                selectedTfsField: FIELDS_MAPPING_NAMESPACE.getters.SELECTED_TFS_FIELD,
                imagePath: APP_NAMESPACE.getters.IMAGE_PATH
            }),
        methods: {
            ...mapActions({
                removeMapping: FIELDS_MAPPING_NAMESPACE.actions.REMOVE_MAPPING,
                mapFields: FIELDS_MAPPING_NAMESPACE.actions.MAP,
                setJiraSelectedValue: FIELDS_MAPPING_NAMESPACE.actions.SET_SELECTED_JIRA_FIELD,
                setTfsSelectedValue: FIELDS_MAPPING_NAMESPACE.actions.SET_SELECTED_TFS_FIELD,
                setMappingAsDefault: FIELDS_MAPPING_NAMESPACE.actions.SET_DEFAULT_MAPPING
            }),
            ...mapGetters({
                 contextPath: APP_NAMESPACE.getters.CONTEXT_PATH,
            }),
            editValues: function(mapping) {
                (this.isWizardView && this.isWizardView === 'true')
                    ?triggerEventAndGoToEditValuesView(mapping)
                    :redirectToEditValuesView(this.contextPath(), this.guid, mapping.Id);
            },
            removeMappingFromGroup: function(mapping, group) {
                this.removeMapping({
                    mapping: mapping,
                    group: group
                });
            },
            addJiraFieldToGroup: function(jiraField, mapping) {
                this.mapFields({
                    jiraField: jiraField,
                    tfsField: mapping.TfsField
                });
                this.setJiraSelectedValue(null);
            },
            addTfsFieldToGroup: function(tfsField, mapping) {
                this.mapFields({
                    jiraField: mapping.JiraField,
                    tfsField: tfsField
                });
                this.setTfsSelectedValue(null);
            },
            setAsDefault: function(mapping) {
                this.setMappingAsDefault(mapping);
            }
        }
    }

    const redirectToEditValuesView = function(contextPath, profileGuid, mappingId) {
        window.location.href = contextPath + '/Tfs/Index/' + profileGuid+ '?mappings=1&mappingid=' + mappingId;
    }

    const triggerEventAndGoToEditValuesView = function(mapping) {
        $('#field-mapping-component').trigger('EditMappingButtonClicked',{
                        jiraId: mapping.JiraField.Key,
                        tfsId: mapping.TfsField.Key,
                        mappingId: mapping.Id
                    });
    }
</script>
<style scoped>
    td {
        position: relative;
    }
    button {
        height: 22px;
        line-height: 0;
    }
    button:disabled {
        opacity: 0.4;
        cursor: initial;
    }
    .field-inline-link-button {
        clear: both;
        color: #326CA6;
        cursor: pointer;
        position: relative;
        top: .3em;
    }
    .field-inline-link-button:hover {
        text-decoration: underline;
    }
    .mapping-value-settings{
        float: right;
    }
    .mapping-value-settings span {
        margin-right: .5em;
    }
    .mapping-value-settings img{
        width: .7em;
        vertical-align: middle;
        color: #404040;
    }
    .mapping-value-settings img:hover{
       cursor: pointer;
    }
    table {
        width: 100%;
        border: 0;
        border-collapse: collapse;
    }
    tbody {
        display: table-row-group;
        vertical-align: middle;
        border-color: inherit;
        position: relative;
        border-bottom: 1px solid #ccc;
    }
    tbody > tr {
        border-bottom: 0;
    }
    .fields-mapping-group-settings {
        float: right;
    }
    .fields-mapping-default {
        font-size: .7rem;
        border-radius: 3px;
        padding: .2em .4em;
        background-color: #fff;
    }
    .fields-mapping-default {
        border: 1px solid #78b1e4;
    }
    .fields-mapping-set-default {
        display: none;
    }
    .fields-mapping-set-default:hover {
        cursor: pointer;
    }
    tbody:hover .fields-mapping-set-default {
        display: block;
    }
    .field-info-icon {
        color: #326CA6;
        top: .1em;
        left: .2em;
        position: relative;
        height: 0.9em;
    }
    .field-info-icon:hover {
        cursor: pointer;
    }
    .mapping-value-settings button {
        margin: .1em .2em;
    }
    .mapping-set-primary {
        box-sizing: border-box;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        font-size: 12px;
        width: 7em;
    }
    .mapping-row-settings {
        box-sizing: border-box;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        width: 4em;
    }
    tbody [rowspan] {
      border-bottom: 1px solid #ccc;
    }
    .tfs4jira-mapping-table td {
        padding: .5em 0;
    }
    .tfs4jira-mapping-row-left {
        width: 22em;
    }
    .tfs4jira-mapping-remove img {
        width: .5em;
    }
    .mapping-needs-attention {
        border: .5px solid #ff00007d;
    }
    .info {
        background-image: url('../assets/Info.svg');
        background-repeat: no-repeat;
        background-size: cover;
        width: 18px;
        height: 18px;
        display: inline-block;
    }
    .warning {
        background-image: url('../assets/Warning.svg');
        background-repeat: no-repeat;
        background-size: cover;
        width: 18px;
        height: 18px;
        display: inline-block;
    }
</style>


// WEBPACK FOOTER //
// src/components/FieldsMappingRow.vue